import SizedDatePickerDataInput from '../../../repertoire/components/dateDataInput/DatePickerDataInput';

export const DatePickerComponent = ({ field, form, ...props }) => {
    const handleDateChange = (value: string | boolean | Date, fieldName?: string, index?: number) => {
        form.setFieldValue(field.name, value);
    };

    return (
        <SizedDatePickerDataInput
            value={field.value || ""} 
            fieldName={field.name || ""} 
            changeData={handleDateChange}
            label={props.label}
            isHidden={props.isHidden || false}
            isMandatory={props.isMandatory || false}
            readOnly={false}
            placeholder={props.placeholder}
        />
    );
};